module.exports = __webpack_public_path__ + "img/icon_city7.864ef5e1.png";